import * as React from 'react';
import { useForm, useFormState, useFormContext, useWatch, useFieldArray, Controller } from 'react-hook-form';
import { Box, Button, Typography, useMediaQuery, TextField as MuiTextField, Breadcrumbs } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
    List,
    Datagrid,
    TextField,
    ReferenceField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    ReferenceInput,
    SelectInput,
    TextInput,
    SimpleList,
    ShowButton,
    FunctionField,
    useTranslate,
    ReferenceManyField,
    SingleFieldList,
    ChipField,
    DateTimeInput,
    PasswordInput,
    ImageInput,
    ImageField,
    TabbedForm,
    FormTab,
    FormDataConsumer,
    AutocompleteArrayInput,
    ArrayInput,
    SimpleFormIterator,
    Show,
    Toolbar,
    SaveButton,
    useGetIdentity,
    Loading,
    useRecordContext,
    TopToolbar
} from 'react-admin';
import LinkToRelatedPosts from './LinkToRelatedPosts';
import { formatDate } from '../utils/util';
import { Consts } from '../consts/Const';
import { display } from '@mui/system';
import { useState } from 'react';
import { AddAlarmSharp, OpenInNewOffOutlined } from '@mui/icons-material';
import { CustomFormTab, TabBasic, TabMallSelections, TabQuestions, TabScoringItems } from './ContestFormComponents';
import Error from '../Error';
import CustomBreadcrumbs from '../layout/Breadcrumbs';

const ContestTitle = ({ record }: any) => {
    return <span>Contest {record ? `"${record.title}"` : ''}</span>;
};

type FormData = {
    title: string;
    subtitle: string;
    description: string;
    areaId: number;
    imageUrl: string;
    publishStart: Date;
    publishEnd: Date;
    applicationStart: Date;
    applicationEnd: Date;
    questions: [
        {
            text: string;
            type: number;
            options: Array<any>;
        }
    ];
};

const ShowActions = ({ currentUser }: any) => {
    const record = useRecordContext();

    if (!record) return <Loading />;

    // 権限別調整
    let isNotPermitted;
    switch (currentUser.authority) {
        case Consts.AUTORITY.area:
            isNotPermitted = record.areaId !== currentUser.areaId;
            break;
        case Consts.AUTORITY.mall:
            isNotPermitted = record.mallId !== currentUser.mallId;
            break;
        case Consts.AUTORITY.maker:
            isNotPermitted = true;
            break;
        default:
            break;
    }

    return (
        <>
            {!isNotPermitted ? (
                <TopToolbar>
                    <EditButton />
                    {/* Add your custom actions */}
                    {/* <Button color="primary" onClick={}>Custom Action</Button> */}
                </TopToolbar>
            ) : null}
        </>
    );
};

const ContestShowContent = ({ currentUser }: any) => {
    const record = useRecordContext();

    if (!record) return <Loading />;

    // 権限別調整
    let isNotPagePermitted;
    switch (currentUser.authority) {
        case Consts.AUTORITY.area:
            break;
        case Consts.AUTORITY.mall:
            isNotPagePermitted = record.areaId !== currentUser.areaId;
            break;
        case Consts.AUTORITY.maker:
            isNotPagePermitted = record.areaId !== currentUser.areaId;
            break;
        default:
            break;
    }

    if (isNotPagePermitted) return <Error type="permission" />;

    return <CustomFormTab currentUser={currentUser} isShow={true} toolbar={<></>} record={record} />;
};

export const ContestShow = () => {
    const { identity: currentUser, isLoading } = useGetIdentity();

    if (isLoading) return <Loading />;

    return (
        <Box>
            <CustomBreadcrumbs
                breadcrumbs={[
                    { url: '/contests', text: 'コンテスト一覧' },
                    { url: null, text: `コンテスト詳細` }
                ]}
            />
            <Show
                title="コンテスト詳細"
                actions={<ShowActions currentUser={currentUser} />}
                sx={{
                    padding: {
                        // xs: '20px 10px',
                        sm: '0px 0px 20px'
                    }
                }}
            >
                <ContestShowContent currentUser={currentUser} />
            </Show>
        </Box>
    );
};
